import defaultMessages from '../i18n/en.js'

const siteURL = new URL(window.location.href)
const baseURL = siteURL.href.slice(0, siteURL.href.indexOf(siteURL.pathname)) + '/template/source/assets/js'
const language = window.motostorm?.lang || 'en'

let messages = defaultMessages

const changeLanguage = async () => {
	import(/* webpackIgnore: true */`${baseURL}/i18n/${language}.js`).then(m => {
		messages = m.default
	})
	.catch(e =>
		console.error(e)
	)
}

const t = (key) => {
	return messages[key] || key
}

changeLanguage()

export default {
	changeLanguage,
	t,
}
export { changeLanguage, t }
